import { CSSProperties, FC } from 'react';
import { Trans } from 'react-i18next';

import ProfileVideo from '@/components/ProfileData/ProfileVideo/ProfileVideo.tsx';
import { useProfileStore } from '@/store/useProfileStore.ts';
import { mainTextStyle } from '@/components/Registration/UserPhotos.tsx';

type ProfileVideoBlockProps = {
  showBadge?: boolean;
  isEdit?: boolean;
  isAnyPhotoUploading?: boolean;
  onUploadingChange?: (uploading: boolean) => void;
};

const ProfileVideoBlock: FC<ProfileVideoBlockProps> = ({
  showBadge = false,
  isEdit = false,
  isAnyPhotoUploading = false,
  onUploadingChange
}) => {
  const { aboutMe } = useProfileStore();
  const hasVideo = (aboutMe?.profile?.v2videos?.length ?? 0) > 0;

  return (
    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
      <div style={{ width: 'calc((100% - 18px) / 3)' }}>
        <ProfileVideo
          isEdit={isEdit}
          isAnyPhotoUploading={isAnyPhotoUploading}
          onUploadingChange={onUploadingChange}
        />
      </div>

      {showBadge && (
        <div style={{ position: 'relative' }}>
          <div style={arrowStyle} />
          <div style={badgeStyle}>
            <div
              style={{
                ...unlockedPhotosGroupStyle,
                filter: hasVideo ? 'none' : 'blur(1px)',
                opacity: hasVideo ? 1 : 0.5
              }}
            >
              <img
                src="/2_unlocked.jpg"
                alt=""
                style={{
                  ...unlockedPhotoStyle,
                  width: 15,
                  height: 15,
                  position: 'absolute',
                  top: 8,
                  right: 2
                }}
              />
              <img
                src="/3_unlocked.jpg"
                alt=""
                style={{
                  ...unlockedPhotoStyle,
                  width: 18,
                  height: 18,
                  position: 'absolute',
                  top: 0,
                  left: 5
                }}
              />
              <img
                src="/1_unlocked.jpg"
                alt=""
                style={{
                  ...unlockedPhotoStyle,
                  width: 20,
                  height: 20,
                  position: 'absolute',
                  bottom: -3,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  zIndex: 1
                }}
              />
            </div>
            <span
              style={{
                ...mainTextStyle,
                color: '#ffffff',
                textAlign: 'left'
              }}
            >
              <Trans
                i18nKey={hasVideo ? 'video.info_unlocked' : 'video.info_locked'}
                components={{ br: <br /> }}
              />
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

const badgeStyle: CSSProperties = {
  width: 180,
  height: 65,
  background: 'linear-gradient(90deg, #8681FA 0%, #D16FD9 100%)',
  borderRadius: '20px',
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
  padding: '0 12px'
};

const unlockedPhotosGroupStyle: CSSProperties = {
  position: 'relative',
  display: 'flex',
  flexShrink: 0,
  width: 40,
  height: 38
};

const unlockedPhotoStyle: CSSProperties = {
  borderRadius: '50%',
  objectFit: 'cover'
};

const arrowStyle: CSSProperties = {
  position: 'absolute',
  left: -6,
  top: '50%',
  transform: 'translateY(-50%)',
  width: 0,
  height: 0,
  borderTop: '6px solid transparent',
  borderBottom: '6px solid transparent',
  borderRight: '6px solid #8681FA'
};

export default ProfileVideoBlock;
